import React from 'react'
import styles from './List.module.css'
import resourcesIcon from '../../assets/left_menu/recursos.svg'
import libraryIcon from '../../assets/left_menu/library.svg'
import eventIcon from '../../assets/left_menu/icono-calendario-verde.svg'
import trainingIcon from '../../assets/left_menu/ejercicios-inact.svg'
import formIcon from '../../assets/left_menu/formularios-inact.svg'

import { EventType } from '../../modules/notifications/enums/EventType'

interface ActivityWidgetIconProps {
  type: EventType
}

export function ActivityWidgetIcon({ type }: ActivityWidgetIconProps): JSX.Element {
  switch (type) {
    case EventType.ResourceShared:
    case EventType.ResourceUpdated:
      return <img className={styles.icon} src={resourcesIcon} alt="Resources icon" />

    case EventType.ArticlePublished:
    case EventType.ArticleUpdated:
      return <img className={styles.icon} src={libraryIcon} alt="Library icon" />

    case EventType.AppointmentCreated:
    case EventType.AppointmentUpdated:
    case EventType.AppointmentCancelled:
    case EventType.CalendarEventCreated:
    case EventType.CalendarEventReminder:
      return <img className={styles.icon} src={eventIcon} alt="Event icon" />

    case EventType.FormSubmitted:
    case EventType.FormCompleted:
      return <img className={styles.icon} src={formIcon} alt="Form icon" />
    case EventType.TrainingAssigned:
    case EventType.TrainingCompleted:
      return <img className={styles.icon} src={trainingIcon} alt="Training icon" />
    default:
      return <img className={styles.icon} src={eventIcon} alt="Default activity icon" />
  }
}
